export enum UpgradeError {
  INFANT_IN_BOOKING = 'INFANT_IN_BOOKING',
  GROUP_BOOKING = 'GROUP_BOOKING',
  SSR_IN_BOOKING = 'SSR_IN_BOOKING',
  TOO_MANY_PASSENGERS = 'TOO_MANY_PASSENGERS',
  TOO_CLOSE_TO_DEPARTURE_FOR_WAITLIST = 'TOO_CLOSE_TO_DEPARTURE_FOR_WAITLIST',
  TOO_CLOSE_TO_DEPARTURE = 'TOO_CLOSE_TO_DEPARTURE',
  INELIGIBLE_BOOKING_CLASS = 'INELIGIBLE_BOOKING_CLASS',
  SEGMENT_IN_REQUESTED_UPGRADE_CABIN = 'SEGMENT_IN_REQUESTED_UPGRADE_CABIN',
  SEGMENT_MISSING_REQUESTED_UPGRADE_CABIN = 'SEGMENT_MISSING_REQUESTED_UPGRADE_CABIN',
  TOO_FAR_TO_DEPARTURE = 'TOO_FAR_TO_DEPARTURE',
  BOOKING_IN_INELIGIBLE_STATUS = 'BOOKING_IN_INELIGIBLE_STATUS',
  NOT_FINNAIR_FLIGHT = 'NOT_FINNAIR_FLIGHT',
  NOT_OPERATED_BY_FINNAIR = 'NOT_OPERATED_BY_FINNAIR',
  FLOWN_SEGMENT = 'FLOWN_SEGMENT',
  TICKET_NOT_ISSUED_BY_FINNAIR = 'TICKET_NOT_ISSUED_BY_FINNAIR',

  /**
   * Errors below are dynamically created in the frontend and not coming from the API.
   */
  INVALID_BOOKING_REF = 'INVALID_BOOKING_REF',
  HTTP_ERROR = 'HTTP_ERROR',
  INSUFFICIENT_PAYMENT = 'INSUFFICIENT_PAYMENT',
  IN_PROGRESS = 'IN_PROGRESS',
  ON_WAITLIST = 'ON_WAITLIST',
  ALREADY_UPGRADED = 'ALREADY_UPGRADED',
  NOT_LOGGED_IN = 'NOT_LOGGED_IN',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  NONE = '',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  FAILED = 'FAILED',
  INSUFFICIENT_SEATS = 'INSUFFICIENT_SEATS',
  TRAIN_CONNECTION = 'TRAIN_CONNECTION',
  BUS_CONNECTION = 'BUS_CONNECTION',
  NO_REMAINING_UPGRADES = 'NO_REMAINING_UPGRADES',
  ONLY_ECONOMY_AVAILABLE = 'ONLY_ECONOMY_AVAILABLE',
}
